import React from 'react';
import { Link } from "react-router-dom";
import UpcomingTreks from './UpcomingTreks';
import Comma from '../../images/Comma.png'
import { BiLogoWhatsapp } from "react-icons/bi";

function HomePage() {
  return (
    <section id="home" className="d-flex align-items-center homePage">
      <a target="_blank" rel="noreferrer" href="https://api.whatsapp.com/send?phone=919535117707&text=Hi, Hoolla's Trekking!" class="whatsapp-button"><BiLogoWhatsapp/></a>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 order-2 order-lg-1 d-flex flex-column justify-content-center">
            <div className='homeSection aboutInHome'>
              <h3 className="fontColor-1">WELCOME TO HOLLA'S TREKKING!</h3>
              {/* <p className='home-para fontColor-1'>"The world reveals itself to those who travel on foot.."</p> */}
              <div>
               <a href="/displayAllTreks" className="btn-get-started-home">PICK YOUR NEXT ADVENTURE</a>
              </div>
            </div>
            <div>
              <div className='aboutInHome'>ABOUT HOLLA'S TREKKERS</div>
              <div className='aboutPara'>
                <p>We are a small and dedicated team who specialize in harmonizing adventurous travelers with their dream vacations. We are passionate about trekking, wild places, and conservation and we are always happy to share our wilderness discoveries with others.</p>
              </div>
              <div className='aboutPara'>
                <p>In addition to curating unforgettable journeys for adventurous souls, we prioritize sustainable travel practices and strive to minimize our ecological footprint. Our itineraries are crafted with careful consideration for the environment and local communities, fostering responsible tourism that benefits both travelers and destinations alike. Whether it's exploring remote trails, encountering rare wildlife, or immersing oneself in indigenous cultures, we believe in fostering meaningful connections with nature while promoting conservation efforts.</p>
              </div>
            </div>
            <div className='aboutInHome upcomingTrek'>CHECK UPCOMING TREKS</div>
            <UpcomingTreks/>
            <div>
              <div className='aboutInHome'>TREKKER REVIEWS</div>
              <div className='testimonialPara'>
                <div className="testimonial-card">
                  <p className='testimonialPara'><img src={Comma} width="30" height="30" style={{marginTop: '-15px'}} />
                  Maza agaya. It was nothing short of breathtaking! Surrounded by nature's finest, every turn revealed a new wonder  from lush greenery to the majestic waterfalls. With the knowledgeable guides leading the way, it felt like stepping into a dream. This trek is a hidden gem for anyone craving an adventure that touches the soul."</p>
                  <p className="testimonial-author">- Jethalal Champaklal Gada</p>
                </div>
                <div className="testimonial-card">
                  <p className='testimonialPara'><img src={Comma} width="30" height="30" style={{marginTop: '-15px'}} /> Apratheem trek tha. As I reflect on my trekking experience with Hollas Trekking, the Gokarna Beach camping excursion stands out as a truly magical journey. The tranquil beauty of the beaches combined with the impeccable guidance from the team created an unforgettable adventure. Hollas Trekking ensured every moment was filled with awe and wonder, making this expedition an absolute delight."</p>
                  <p className="testimonial-author">- Atmaram Thukaram Bhide</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomePage;